import { render, staticRenderFns } from "./EndBooking.vue?vue&type=template&id=066f2dd0&scoped=true"
import script from "./EndBooking.vue?vue&type=script&lang=js"
export * from "./EndBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066f2dd0",
  null
  
)

export default component.exports